import { render, staticRenderFns } from "./ProteinDomainRows.vue?vue&type=template&id=897e32ce&scoped=true"
import script from "./ProteinDomainRows.vue?vue&type=script&lang=js"
export * from "./ProteinDomainRows.vue?vue&type=script&lang=js"
import style0 from "./ProteinDomainRows.vue?vue&type=style&index=0&id=897e32ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897e32ce",
  null
  
)

export default component.exports